import { Col } from 'react-bootstrap';
import { FiUpload } from 'react-icons/fi';
import styles from '../../../register/style.module.scss';
import PropTypes from 'prop-types';
import React from 'react';

export const FileInput = ({ name, label, placeholder, handleImage, handleClick }) => (
  <Col>
    <p className={`${styles.customLabel} my-2`}>{label}</p>
    <label htmlFor={name} className={styles.styled_label}>
      <div className="d-flex justify-content-between">
        {placeholder} <FiUpload className={styles.upload_icon} />
      </div>
      <input
        type="file"
        multiple
        accept="image/*"
        id={name}
        className="d-none"
        onChange={(e) => {
          handleImage(e, name);
        }}
        onClick={handleClick}
      />
    </label>
  </Col>
);
FileInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  handleImage: PropTypes.func,
  handleClick: PropTypes.func,
};

export const UploadedMedia = ({ name, source, removeImage, sourceType = 'image/' }) => (
  <div className={`${styles.relative} d-flex justify-content-center`}>
    {source && (
      <>
        <span onClick={() => removeImage(name)}>X</span>
        {sourceType === 'application/pdf' || sourceType === 'pdf' ? (
          <iframe
            src={source}
            style={{
              pointerEvents: 'none',
              border: 'none',
              overflow: 'hidden',
              overflowY: 'hidden',
            }}
            width="100%"
          />
        ) : (
          <img src={source} width={150} alt={name} />
        )}
      </>
    )}
  </div>
);

UploadedMedia.propTypes = {
  name: PropTypes.string,
  source: PropTypes.string,
  removeImage: PropTypes.func,
  sourceType: PropTypes.string,
};
